<template>
  <a-card :bordered="false">
    <custom-page-table
      ref="table"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise">
      <template slot="proSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.proName }}</div>
        <div>票型：{{ rowItem.record.optionName }}</div>
      </template>
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.phone }}</div>
      </template>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'BusOrderConnection',
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '供应商订单号',
          dataIndex: 'supplerOrderNo',
          width: '120px'
        },
        {
          title: '关联订单号',
          dataIndex: 'orderNo',
          width: '120px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          scopedSlots: { customRender: 'proSlot' },
          width: '25%'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '出游日期',
          dataIndex: 'travelTime',
          width: '110px'
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          width: '110px'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BusConnection', title: '商品绑定' },
      { name: 'BusOrderConnection', title: '订单直连' },
      { name: 'BusNewAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('ydBus/getBusOrderPage', params)
    }
  }
}
</script>
<style scoped></style>
